import React from 'react';
import { node, string } from 'prop-types';

import css from './Waiting.less';

function Waiting({ name, avatar, text }) {
  return (
    <div className={css.container}>
      <div className={css.ava}>{avatar}</div>
      <div className={css.patientName}>{name}</div>
      <div className={css.connecting}>{text}</div>
    </div>
  );
}

Waiting.propTypes = {
  name: string,
  avatar: node.isRequired,
  text: string.isRequired,
};

Waiting.defaultProps = {
  name: '',
};

export default Waiting;
